
import { defineComponent } from 'vue'

import ProfilLeftBar from '@/components/HomeView/ProfilLeftBar.vue'
import BuildingInformationsPannel from '../components/HomeView/BuildingInformationsPannel.vue'
import BuildingContentInformationsPannel from '../components/HomeView/BuildingContentInformationsPannel.vue'
import SyndicPromotePannel from '@/components/HomeView/SyndicPromotePannel.vue'
import ShopPromotePannel from '@/components/HomeView/ShopPromotePannel.vue'
import SupportInfoPannel from '@/components/HomeView/SupportInfoPannel.vue'
import MaintenancePromotePannel from '@/components/HomeView/MaintenancePromotePannel.vue'
import MobileUserProfilePannel from '@/components/HomeView/MobileUserProfilePannel.vue'
import hemisphereService from '@/services/hemisphere.service'
import entitiesProxyService from '@/services/entities-proxy.service'
import { useSession } from '@/composables/auth'
import { useCurrentBuildingId } from '@/composables/currentBuildingId'
import FlexHorizonPromotePannel from '@/components/HomeView/FlexHorizonPromotePannel.vue'

export default defineComponent({
  components: {
    ProfilLeftBar,
    BuildingInformationsPannel,
    BuildingContentInformationsPannel,
    SyndicPromotePannel,
    ShopPromotePannel,
    SupportInfoPannel,
    MaintenancePromotePannel,
    MobileUserProfilePannel,
    FlexHorizonPromotePannel
  },
  setup() {
    let { loggedIn } = useSession()
    return {
      loggedIn,
      getCurrentBuildingId: useCurrentBuildingId()
    }
  },
  data() {
    type BuildingType = {
      [key: string]: any
    }

    return {
      buildings: [] as any[],
      itsInfo: [] as any[],
      gatewaysInfo: [] as any[],
      tagsInfo: [] as any[],
      building: {} as BuildingType,
      licence: {},
      zonesInfo: [] as any[],
      auths: [] as any[],
      itsLoading: false
    }
  },
  async mounted() {
    if (this.loggedIn) {
      const buildingId = await this.getCurrentBuildingId()
      if (buildingId) {
        hemisphereService
          .getBuilding(buildingId)
          .then((resp: any) => {
            this.building = resp.data
            this.licence = this.building.licence
          })
          .catch((err) => {
            console.log(err)
            this.$toast.add({
              severity: 'error',
              summary: "Une erreur s'est produite",
              detail: err.response.data.message,
              life: 3000
            })
          })

        this.itsLoading = true
        entitiesProxyService
          .getItsInfoAccount(buildingId)
          .then((res: any) => {
            this.itsInfo = res.data.filter((it: any) => it.itcategory && it.itcategory != 'GATEWAY' && it.itcategory != 'BRIDGE')
            localStorage.setItem('itsinfo', JSON.stringify({ its: this.itsInfo }))
            this.gatewaysInfo = res.data.filter((it: any) => it.itcategory == 'GATEWAY' || it.itcategory == 'BRIDGE')
            localStorage.setItem('gatewaysinfo', JSON.stringify({ gateways: this.gatewaysInfo }))
            this.itsLoading = false
          })
          .catch((err) => {
            console.log(err)
            this.itsLoading = false
            this.$toast.add({
              severity: 'error',
              summary: "Une erreur s'est produite",
              detail: err.response.data.message,
              life: 3000
            })
          })

        entitiesProxyService
          .getTags(buildingId)
          .then((res: any) => {
            this.tagsInfo = res.data.filter((tag: any) => tag.targetType !== 'IT' && tag.targetType !== 'GATEWAY')
            localStorage.setItem('tagsinfo', JSON.stringify({ tags: this.tagsInfo }))
          })
          .catch((err) => {
            console.log(err)
            this.$toast.add({
              severity: 'error',
              summary: "Une erreur s'est produite",
              detail: err.response.data.message,
              life: 3000
            })
          })

        entitiesProxyService
          .getZones(buildingId)
          .then((res: any) => {
            this.zonesInfo = res.data
            localStorage.setItem('zones', JSON.stringify({ zones: this.zonesInfo }))
          })
          .catch((err) => {
            console.log(err)
            this.$toast.add({
              severity: 'error',
              summary: "Une erreur s'est produite",
              detail: err.response.data.message,
              life: 3000
            })
          })
      } else {
        console.log('no data in session')
      }
    }
  }
})
